function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.6704 10.7603L25.5454 0.339196C25.3345 0.121988 25.0483 0 24.75 0H3.37499C1.51405 0 0 1.55831 0 3.47368V40.5263C0 42.4417 1.51405 44 3.37499 44H32.625C34.486 44 36 42.4418 36 40.5263V11.5789C36 11.2718 35.8814 10.9773 35.6704 10.7602V10.7603ZM33.284 11.5789H25.875C25.2547 11.5789 24.75 11.0595 24.75 10.421V2.79533L33.284 11.5789V11.5789ZM3.37495 41.6842H32.625L32.6249 41.6843C33.2452 41.6843 33.7499 41.1649 33.7499 40.5264V13.8948H25.8749C24.0139 13.8948 22.4999 12.3365 22.4999 10.4211V2.31585H3.37495C2.75462 2.31585 2.24994 2.8353 2.24994 3.47373V40.5264C2.24994 41.1648 2.75462 41.6842 3.37495 41.6842Z",
  fill: "#A5A5A5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.72 30.8H25.56C24.9635 30.8 24.48 30.1434 24.48 29.3334C24.48 28.5233 24.9635 27.8667 25.56 27.8667H27.72C28.3165 27.8667 28.8 28.5233 28.8 29.3334C28.8 30.1434 28.3165 30.8 27.72 30.8Z",
  fill: "#A5A5A5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.72 36.6667H25.56C24.9635 36.6667 24.48 36.0101 24.48 35.2001C24.48 34.39 24.9635 33.7334 25.56 33.7334H27.72C28.3165 33.7334 28.8 34.39 28.8 35.2001C28.8 36.0101 28.3165 36.6667 27.72 36.6667Z",
  fill: "#A5A5A5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.12 20.5332C14.4951 20.5332 13.9885 21.0491 13.9885 21.6856V22.8379C10.2453 22.8379 7.19995 25.9396 7.19995 29.7522C7.19995 33.5648 10.2453 36.6665 13.9885 36.6665C17.7318 36.6665 20.7771 33.5648 20.7771 29.7522H21.9085C22.5334 29.7522 23.04 29.2363 23.04 28.5999C23.04 24.1519 19.487 20.5332 15.12 20.5332ZM16.2514 22.9537C18.4645 23.4132 20.2123 25.1933 20.6634 27.4475H16.2514V22.9537ZM9.46277 29.7522C9.46277 32.294 11.493 34.3618 13.9885 34.3618L13.9885 34.3617C16.484 34.3617 18.5142 32.2939 18.5142 29.7522H15.1199C14.4951 29.7522 13.9885 29.2363 13.9885 28.5998V25.1427C11.493 25.1427 9.46277 27.2105 9.46277 29.7522Z",
  fill: "#A5A5A5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.72 26.4001H25.56C24.9635 26.4001 24.48 25.7435 24.48 24.9335C24.48 24.1234 24.9635 23.4668 25.56 23.4668H27.72C28.3165 23.4668 28.8 24.1234 28.8 24.9335C28.8 25.7435 28.3165 26.4001 27.72 26.4001Z",
  fill: "#A5A5A5"
});

var SvgPdfIcon = function SvgPdfIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf-icon.18203ad3.svg";
export { ForwardRef as ReactComponent };